(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('ModerationOrganisation', ModerationOrganisation);

        ModerationOrganisation.$inject = ['$resource'];

    function ModerationOrganisation ($resource) {
        var service = $resource('api/moderation/organisation/:id', {}, {
            'queryCompany': {method: 'GET', isArray: true, url: '/api/moderation/organisation/company'},
            'queryCollectivity': {method: 'GET', isArray: true, url: '/api/moderation/organisation/collectivity'},
            'get': {
                method: 'GET',
                url: 'api/moderation/organisation/:id',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'mupdate': { 
                method:'POST',
                url: '/api/moderation/organisation/update'
            },
            'msave': { 
                method:'POST',
                url: '/api/moderation/organisation/add'
            },
            
            'reject':{
                method:'DELETE',
                url: 'api/moderation/organisation/:id/reject'
            },
            'createAndApprove': { 
                method:'POST',
                url: '/api/moderation/organisation/:id/createAndApprove'
            },
            'updateAndApprove': { 
                method:'PUT',
                url: '/api/moderation/organisation/:id/updateAndApprove'
            },
            'directCreateAndApprove': { 
                method:'POST',
                url: '/api/moderation/organisation/directCreateAndApprove'
            },
            'directUpdateAndApprove': { 
                method:'PUT',
                url: '/api/moderation/organisation/directUpdateAndApprove'
            }
        });

        return service;
    }
})();
